// extracted by mini-css-extract-plugin
export default {"imgBox":"Profile_imgBox__h5--c","img":"Profile_img__OxjY3","list":"Profile_list__VLWq4","line":"Profile_line__onnVj","phone":"Profile_phone__1nMSk"};